import {
  LdsButton,
  LdsSelect,
  LdsToast,
  useToastContext,
} from "@elilillyco/ux-lds-react";
import Select from "react-select";
 
import "./../../assets/scss/overview/createListModal.scss";
import { useEffect, useState, useCallback } from "react";
import {
  FETCH_THPC_DATA,
  CLEAR_CASCADING_OPTIONS,
} from "../../store/createList";
import { FETCH_THPC_LIST } from "../../store/admin";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCascadingOptions } from "../../utils/useCascadingOptions";
 
const normalizeQuarterValue = (quarter) => {
  if (!quarter) return "";
  // Already in new format e.g. "Q2 2026"
  if (/^Q[1-4] \d{4}$/.test(quarter)) return quarter;
  // Old format e.g. "Q2" - map to the matching quarter in the 4-quarter window
  const match = quarter.match(/^Q([1-4])$/);
  if (!match) return "";
  const qNum = parseInt(match[1]);
  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  let currentQ;
  if (month <= 3) currentQ = 1;
  else if (month <= 6) currentQ = 2;
  else if (month <= 9) currentQ = 3;
  else currentQ = 4;
  for (let i = 0; i < 4; i++) {
    const q = ((currentQ - 1 + i) % 4) + 1;
    const y = year + Math.floor((currentQ - 1 + i) / 4);
    if (q === qNum) return `Q${q} ${y}`;
  }
  return "";
};

const EditBrandIndication = ({
  modalType,
  closeBrandIndicationEdit,
  saveMetaData,
}) => {
  const dispatch = useDispatch();
  useToastContext();
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
 
  // Use cascading options hook
  const {
    cascadingOptions,
    cascadingLoading,
    fetchCascadingOptions,
    resetCascadingState,
  } = useCascadingOptions();
 
  const { thpcdata, loading } = useSelector(({ createlist }) => createlist);
  const { uuid } = useSelector(({ user }) => user);
  const { specialtyList } = useSelector(({ details }) => details);
  const { thpc: adminThpcData, thpcLoading } = useSelector(({ admin }) => admin);
 
  const [selectedDepartment, setSelectedDepartment] = useState(
    specialtyList?.department_field ? specialtyList.department_field : ""
  );
  const [selectListType, setSelectListType] = useState(
    specialtyList?.list_type ? specialtyList.list_type : ""
  );
  // selected values
  const [selectedthpc, setSelectedthpc] = useState(
    specialtyList?.thpc_nm ? specialtyList.thpc_nm : ""
  );
  const [selecteddsst, setSelecteddsst] = useState(
    specialtyList?.dsst_nm ? specialtyList.dsst_nm : ""
  );
  const [selectedindication, setSelectedindication] = useState(
    specialtyList?.indication_nm ? specialtyList.indication_nm : ""
  );
  // eslint-disable-next-line no-unused-vars
  const [selectedindicationgrp, setSelectedindicationgrp] = useState(
    specialtyList?.indication_grp_nm ? specialtyList.indication_grp_nm : ""
  );
  const [selectedbrand, setSelectedbrand] = useState(
    specialtyList?.brand_nm ? specialtyList.brand_nm : ""
  );
  const [selectedmoelcule, setSelectedmoelcule] = useState(
    specialtyList?.mdpr_nm ? specialtyList.mdpr_nm : ""
  );
  const [listQuarter, setListQuarter] = useState(
    normalizeQuarterValue(specialtyList?.list_quarter || "")
  );
  // selected flags
  const [isQuarterSelected, setIsQuarterSelected] = useState(
    specialtyList?.list_quarter ? true : false
  );
  const [isThpcSelected, setIsThpcSelected] = useState(
    specialtyList?.thpc_nm ? true : false
  );
  const [isDsstSelected, setIsDsstSelected] = useState(
    specialtyList?.dsst_nm ? true : false
  );
  const [isMoleculeSelected, setIsMoleculeSelected] = useState(
    specialtyList?.mdpr_nm ? true : false
  );
  const [isIndicationSelected, setIsIndicationSelected] = useState(
    specialtyList?.indication_nm ? true : false
  );
  const [isBrandSelected, setIsBrandSelected] = useState(
    specialtyList?.brand_nm ? true : false
  );
  // next button disabled
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);
  // initial render
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [isInitialRenderlt, setIsInitialRenderlt] = useState(true);
 
  // Fetch admin THPC list (for scratch mode) and existing lists data (for existing mode)
  useEffect(() => {
    if (!modalType) {
      dispatch(FETCH_THPC_LIST());
    }
    if (modalType && selectedDepartment) {
      dispatch(
        FETCH_THPC_DATA({
          search_keyword: "",
          list_type: "",
          clone_type: "existing",
          department_field: selectedDepartment,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, modalType]);
 
  // Fetch cascading options for initial values on mount
  useEffect(() => {
    if (isInitialRender && selectedthpc && selectedDepartment && selectListType) {
      fetchCascadingOptions({
        field_type: "disease_state",
        department_field: selectedDepartment,
        list_type: selectListType,
        clone_type: modalType ? "existing" : "scratch",
        thpc_nm: selectedthpc,
      });
 
      if (selecteddsst) {
        if (selectListType === "thpc&dsst&mdpr") {
          fetchCascadingOptions({
            field_type: "molecule",
            department_field: selectedDepartment,
            list_type: selectListType,
            clone_type: modalType ? "existing" : "scratch",
            thpc_nm: selectedthpc,
            dsst_nm: selecteddsst,
          });
        }
        if (selectListType === "brnd&ind") {
          fetchCascadingOptions({
            field_type: "brand",
            department_field: selectedDepartment,
            list_type: selectListType,
            clone_type: modalType ? "existing" : "scratch",
            thpc_nm: selectedthpc,
            dsst_nm: selecteddsst,
          });
          if (selectedbrand) {
            fetchCascadingOptions({
              field_type: "indication",
              department_field: selectedDepartment,
              list_type: selectListType,
              clone_type: modalType ? "existing" : "scratch",
              thpc_nm: selectedthpc,
              dsst_nm: selecteddsst,
              brand_nm: selectedbrand,
            });
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialRender, adminThpcData, thpcdata]);
 
  // Reset other state if selectedDepartment changes
  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      setSelectListType(specialtyList?.list_type || "");
      setSelectedthpc(specialtyList?.thpc_nm || "");
      setSelecteddsst(specialtyList?.dsst_nm || "");
      setSelectedindication(specialtyList?.indication_nm || "");
      setSelectedindicationgrp(specialtyList?.indication_grp_nm || "");
      setSelectedbrand(specialtyList?.brand_nm || "");
      setSelectedmoelcule(specialtyList?.mdpr_nm || "");
      setListQuarter(normalizeQuarterValue(specialtyList?.list_quarter || ""));
    } else {
      setSelectListType("");
      setSelectedthpc("");
      setSelecteddsst("");
      setSelectedindication("");
      setSelectedindicationgrp("");
      setSelectedbrand("");
      setSelectedmoelcule("");
      setListQuarter("");
      resetCascadingState();
    }
    setIsQuarterSelected(specialtyList?.list_quarter ? true : false);
    setIsThpcSelected(specialtyList?.thpc_nm ? true : false);
    setIsDsstSelected(specialtyList?.dsst_nm ? true : false);
    setIsMoleculeSelected(specialtyList?.mdpr_nm ? true : false);
    setIsIndicationSelected(specialtyList?.indication_nm ? true : false);
    setIsBrandSelected(specialtyList?.brand_nm ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment]);
 
  // Reset all state except selectedDepartment if selectListType changes
  useEffect(() => {
    if (isInitialRenderlt) {
      setIsInitialRenderlt(false);
      setSelectedthpc(specialtyList?.thpc_nm || "");
      setSelecteddsst(specialtyList?.dsst_nm || "");
      setSelectedindication(specialtyList?.indication_nm || "");
      setSelectedindicationgrp(specialtyList?.indication_grp_nm || "");
      setSelectedbrand(specialtyList?.brand_nm || "");
      setSelectedmoelcule(specialtyList?.mdpr_nm || "");
      setListQuarter(normalizeQuarterValue(specialtyList?.list_quarter || ""));
    } else {
      setSelectedthpc("");
      setSelecteddsst("");
      setSelectedindication("");
      setSelectedindicationgrp("");
      setSelectedbrand("");
      setSelectedmoelcule("");
      setListQuarter("");
      resetCascadingState();
    }
    setIsQuarterSelected(specialtyList?.list_quarter ? true : false);
    setIsThpcSelected(specialtyList?.thpc_nm ? true : false);
    setIsDsstSelected(specialtyList?.dsst_nm ? true : false);
    setIsMoleculeSelected(specialtyList?.mdpr_nm ? true : false);
    setIsIndicationSelected(specialtyList?.indication_nm ? true : false);
    setIsBrandSelected(specialtyList?.brand_nm ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectListType]);
 
  // Get THPC options for dropdown
  const getThpcOptions = useCallback(() => {
    if (modalType && thpcdata && Array.isArray(thpcdata)) {
      let filteredLists = thpcdata;
      if (selectedDepartment && selectListType) {
        filteredLists = thpcdata.filter((item) => {
          const matchesDepartment = item.department_field === selectedDepartment;
          const matchesListType = item.list_type === selectListType;
          return matchesDepartment && matchesListType;
        });
      }
      const uniqueThpcs = [...new Set(filteredLists.map((item) => item.thpc_nm))].filter(Boolean);
      return uniqueThpcs.map((thpcName) => ({
        label: thpcName,
        value: thpcName,
      }));
    }
 
    if (!modalType && adminThpcData && Array.isArray(adminThpcData)) {
      return adminThpcData
        .map((item) => ({
          label: item.label || item.value || "",
          value: item.value || item.label || "",
        }))
        .filter((item) => item.label && item.value);
    }
 
    return [];
  }, [modalType, thpcdata, adminThpcData, selectedDepartment, selectListType]);
 
  // Format options for dropdown display
  const formatOptionsForDropdown = useCallback((options, fieldType) => {
    if (!options || !Array.isArray(options)) return [];
 
    return options
      .map((item) => {
        if (!item || typeof item !== "object") return null;
        let label = "";
        let value = "";
 
        switch (fieldType) {
          case "dsst":
          case "disease_state":
            label = item.disease_nm || item.dsst_nm || "";
            value = item.disease_nm || item.dsst_nm || "";
            break;
          case "mdpr":
          case "molecule":
            label = item.molecule_nm || item.mdpr_nm || "";
            value = item.molecule_nm || item.mdpr_nm || "";
            break;
          case "brand":
            label = item.brnd_nm || item.brand_nm || "";
            value = item.brnd_nm || item.brand_nm || "";
            break;
          case "indication":
            label = item.indctn_grp_nm || item.indication_nm || "";
            value = item.indctn_grp_nm || item.indication_nm || "";
            break;
          default:
            label = item.label || item.name || "";
            value = item.value || item.name || "";
        }
 
        return { label, value };
      })
      .filter((item) => item && item.label && item.value);
  }, []);
 
  // Button validation using cascading options
  useEffect(() => {
    const quarterSelected = checkSFRole() ? isQuarterSelected : true;
 
    const thpcOptions = getThpcOptions();
    const dsstOptions = formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst");
    const moleculeOptions = formatOptionsForDropdown(cascadingOptions.molecule || [], "mdpr");
    const brandOptions = formatOptionsForDropdown(cascadingOptions.brand || [], "brand");
    const indicationOptions = formatOptionsForDropdown(cascadingOptions.indication || [], "indication");
 
    if (selectedDepartment === "MEDICAL" && selectListType === "thpconly") {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          thpcOptions.some((item) => item.value === selectedthpc)
        )
      );
    } else if (selectedDepartment === "MEDICAL" && selectListType === "thpc&dsst") {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          thpcOptions.some((item) => item.value === selectedthpc) &&
          dsstOptions.some((item) => item.value === selecteddsst)
        )
      );
    } else if (selectedDepartment === "MEDICAL" && selectListType === "thpc&dsst&mdpr") {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          isMoleculeSelected &&
          thpcOptions.some((item) => item.value === selectedthpc) &&
          dsstOptions.some((item) => item.value === selecteddsst) &&
          moleculeOptions.some((item) => item.value === selectedmoelcule)
        )
      );
    } else if (selectedDepartment === "RETAIL" && selectListType === "brnd&ind") {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          isBrandSelected &&
          isIndicationSelected &&
          thpcOptions.some((item) => item.value === selectedthpc) &&
          dsstOptions.some((item) => item.value === selecteddsst) &&
          brandOptions.some((item) => item.value === selectedbrand) &&
          indicationOptions.some((item) => item.value === selectedindication)
        )
      );
    } else if (selectedDepartment === "RETAIL" && selectListType === "thpc&dsst&mdpr") {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          isMoleculeSelected &&
          thpcOptions.some((item) => item.value === selectedthpc) &&
          dsstOptions.some((item) => item.value === selecteddsst) &&
          moleculeOptions.some((item) => item.value === selectedmoelcule)
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isBrandSelected,
    isIndicationSelected,
    isQuarterSelected,
    isThpcSelected,
    isDsstSelected,
    isMoleculeSelected,
    selectedthpc,
    selecteddsst,
    selectedindication,
    selectedbrand,
    selectedmoelcule,
    listQuarter,
    modalType,
    selectListType,
    selectedDepartment,
    cascadingOptions,
    getThpcOptions,
    formatOptionsForDropdown,
  ]);
 
  // Handle cascading when THPC changes
  useEffect(() => {
    if (selectedthpc && selectedDepartment && selectListType) {
      setSelecteddsst("");
      setSelectedbrand("");
      setSelectedindication("");
      setSelectedmoelcule("");
      setIsDsstSelected(false);
      setIsBrandSelected(false);
      setIsIndicationSelected(false);
      setIsMoleculeSelected(false);
 
      dispatch(
        CLEAR_CASCADING_OPTIONS({
          fieldTypes: ["disease_state", "molecule", "brand", "indication"],
        })
      );
 
      fetchCascadingOptions({
        field_type: "disease_state",
        department_field: selectedDepartment,
        list_type: selectListType,
        clone_type: modalType ? "existing" : "scratch",
        thpc_nm: selectedthpc,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedthpc]);
 
  // Handle cascading when disease state changes
  useEffect(() => {
    if (selecteddsst && selectedthpc && selectedDepartment && selectListType) {
      setSelectedbrand("");
      setSelectedindication("");
      setSelectedmoelcule("");
      setIsBrandSelected(false);
      setIsIndicationSelected(false);
      setIsMoleculeSelected(false);
 
      dispatch(
        CLEAR_CASCADING_OPTIONS({
          fieldTypes: ["molecule", "brand", "indication"],
        })
      );
 
      if (selectListType === "thpc&dsst&mdpr") {
        fetchCascadingOptions({
          field_type: "molecule",
          department_field: selectedDepartment,
          list_type: selectListType,
          clone_type: modalType ? "existing" : "scratch",
          thpc_nm: selectedthpc,
          dsst_nm: selecteddsst,
        });
      }
 
      if (selectListType === "brnd&ind") {
        fetchCascadingOptions({
          field_type: "brand",
          department_field: selectedDepartment,
          list_type: selectListType,
          clone_type: modalType ? "existing" : "scratch",
          thpc_nm: selectedthpc,
          dsst_nm: selecteddsst,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selecteddsst]);
 
  // Handle cascading when brand changes (for indication)
  useEffect(() => {
    if (selectedbrand && selecteddsst && selectedthpc && selectedDepartment && selectListType === "brnd&ind") {
      setSelectedindication("");
      setIsIndicationSelected(false);
 
      dispatch(
        CLEAR_CASCADING_OPTIONS({
          fieldTypes: ["indication"],
        })
      );
 
      fetchCascadingOptions({
        field_type: "indication",
        department_field: selectedDepartment,
        list_type: selectListType,
        clone_type: modalType ? "existing" : "scratch",
        thpc_nm: selectedthpc,
        dsst_nm: selecteddsst,
        brand_nm: selectedbrand,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedbrand]);
 
  const checkSFRole = () => {
    if (sessionStorage.getItem("role") === "spclty_hub_hcp_sf_marketer") {
      return true;
    }
    return false;
  };
 
  // eslint-disable-next-line no-unused-vars
  const checkOmnichannelAdvisorRole = () => {
    if (sessionStorage.getItem("role") === "spclty_hub_omnichannel_advisor") {
      return true;
    }
    return false;
  };
 
  /**
   * Gets department options based on user role
   */
  const getDepartmentOptions = () => {
    const role = sessionStorage.getItem("role");
 
    const allOptions = [
      { value: "", label: "Select" },
      { value: "RETAIL", label: "Commercial" },
      { value: "MEDICAL", label: "Medical" },
    ];
 
    if (role === "spclty_hub_hcp_marketer") {
      return [
        { value: "", label: "Select" },
        { value: "RETAIL", label: "Commercial" },
      ];
    }
 
    if (role === "spclty_hub_omnichannel_advisor") {
      return [
        { value: "", label: "Select" },
        { value: "MEDICAL", label: "Medical" },
      ];
    }
 
    return allOptions;
  };
 
  // Dropdown change handlers
  const handlethpcChange = (option) => {
    const value = option?.value || "";
    setSelectedthpc(value);
    setIsThpcSelected(!!value);
  };
 
  const handledsstChange = (option) => {
    const value = option?.value || "";
    setSelecteddsst(value);
    setIsDsstSelected(!!value);
  };
 
  const handlemoleculeChange = (option) => {
    const value = option?.value || "";
    setSelectedmoelcule(value);
    setIsMoleculeSelected(!!value);
  };
 
  const handleBrandChange = (option) => {
    const value = option?.value || "";
    setSelectedbrand(value);
    setIsBrandSelected(!!value);
  };
 
  const handleIndicationChange = (option) => {
    const value = option?.value || "";
    setSelectedindication(value);
    setIsIndicationSelected(!!value);
  };
 
  // quarter functions
  const handleQuarter = ({ value }) => {
    setListQuarter(value);
    setIsQuarterSelected(!!value);
  };

  const getQuarterOptions = () => {
    const now = new Date();
    const month = now.getMonth() + 1; // 1-12
    const year = now.getFullYear();
    let currentQ;
    if (month <= 3) currentQ = 1;
    else if (month <= 6) currentQ = 2;
    else if (month <= 9) currentQ = 3;
    else currentQ = 4;

    const options = [{ label: "Select", value: "" }];
    for (let i = 0; i < 4; i++) {
      const q = ((currentQ - 1 + i) % 4) + 1;
      const y = year + Math.floor((currentQ - 1 + i) / 4);
      options.push({ label: `Q${q} ${y}`, value: `Q${q} ${y}` });
    }

    return options;
  };
 
  // Helper function to get ID from cascading options
  const getIdFromCascadingOptions = (fieldType, selectedValue) => {
    if (!selectedValue) return "";
 
    let options = [];
    let item = null;
 
    switch (fieldType) {
      case "thpc":
        options =
          cascadingOptions.disease_state ||
          cascadingOptions.molecule ||
          cascadingOptions.brand ||
          cascadingOptions.indication ||
          [];
        if (options.length > 0) {
          item = options.find((opt) => opt.thpc_nm === selectedValue);
          return item?.thpc_id || "";
        }
        return "";
      case "dsst":
      case "disease_state":
        options = cascadingOptions.disease_state || [];
        item = options.find(
          (opt) => opt.disease_nm === selectedValue || opt.dsst_nm === selectedValue
        );
        return item?.dsst_id || "";
      case "mdpr":
      case "molecule":
        options = cascadingOptions.molecule || [];
        item = options.find(
          (opt) => opt.molecule_nm === selectedValue || opt.mdpr_nm === selectedValue
        );
        return item?.mdpr_id || "";
      case "brand":
        options = cascadingOptions.brand || [];
        item = options.find(
          (opt) => opt.brnd_nm === selectedValue || opt.brand_nm === selectedValue
        );
        return item?.brnd_id || "";
      case "indication":
        options = cascadingOptions.indication || [];
        item = options.find(
          (opt) =>
            opt.indctn_nm === selectedValue ||
            opt.indication_nm === selectedValue ||
            opt.indctn_grp_nm === selectedValue
        );
        return item?.indctn_id || item?.indctn_grp_id || "";
      default:
        return "";
    }
  };
 
  const createMetaData = () => {
    const listType = selectListType ? selectListType : "";
   
    // Helper function to construct list title based on the selected fields and order
    const constructListTitle = () => {
      // Extract existing quarter and year from the current list title if it exists
      let existingQuarterYear = "";
      const currentTitle = specialtyList?.list_title || "";
     
      // Check if current title starts with year-quarter pattern or just year pattern
      // Handle formats: "2025-Q1 - ", "2025-Q1-", "2025-" (year only)
      const yearQuarterMatch = currentTitle.match(/^(\d{4}(?:-Q[1-4])?)(?:\s-\s|-)/);
      if (yearQuarterMatch) {
        existingQuarterYear = yearQuarterMatch[1];
      }
     
      // Build title parts based on the field order for the list type
      let titleParts = [];
     
      // Add THPC if selected
      if (selectedthpc) {
        titleParts.push(selectedthpc);
      }
     
      // Add DSST if selected
      if (selecteddsst) {
        titleParts.push(selecteddsst);
      }
     
      // For RETAIL brnd&ind: add Brand then Indication
      if (selectedDepartment === "RETAIL" && selectListType === "brnd&ind") {
        if (selectedbrand) {
          titleParts.push(selectedbrand);
        }
        if (selectedindication) {
          titleParts.push(selectedindication);
        }
      }
     
      // For MEDICAL or RETAIL thpc&dsst&mdpr: add Molecule
      if (selectListType === "thpc&dsst&mdpr" && selectedmoelcule) {
        titleParts.push(selectedmoelcule);
      }
     
      // Construct final title with existing quarter/year preserved
      if (existingQuarterYear) {
        // Determine the separator format used in the current title
        const usesSpacedSeparator = currentTitle.includes(" - ");
        const separator = usesSpacedSeparator ? " - " : "-";
       
        // If a new quarter is selected, build the YYYY-QN prefix
        if (listQuarter) {
          // New format: "Q1 2026" → convert to "2026-Q1"
          const quarterWithYearMatch = listQuarter.match(/^Q([1-4])\s+(\d{4})$/);
          if (quarterWithYearMatch) {
            const updatedQuarterYear = `${quarterWithYearMatch[2]}-Q${quarterWithYearMatch[1]}`;
            return updatedQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
          }
          // Old format: "Q1" (no year) → preserve existing year
          const existingYear = existingQuarterYear.match(/^(\d{4})/);
          if (existingYear) {
            const updatedQuarterYear = existingYear[1] + "-" + listQuarter;
            return updatedQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
          }
          return listQuarter + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
        } else {
          // No new quarter selected, keep existing quarter/year
          return existingQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
        }
      } else {
        // If no existing quarter/year and new quarter is selected, add it
        // Default to spaced separator for new titles
        if (listQuarter) {
          // New format: "Q1 2026" → convert to "2026-Q1"
          const quarterWithYearMatch = listQuarter.match(/^Q([1-4])\s+(\d{4})$/);
          const titlePrefix = quarterWithYearMatch
            ? `${quarterWithYearMatch[2]}-Q${quarterWithYearMatch[1]}`
            : listQuarter;
          return titlePrefix + (titleParts.length > 0 ? " - " + titleParts.join(" - ") : "");
        }
        return titleParts.join(" - ");
      }
    };
 
    let obj = {};
    const listTitle = constructListTitle();
   
    if (modalType) {
      if (selectedDepartment === "RETAIL") {
       if(selectListType === "brnd&ind"){
         const data = thpcdata.find(
          (item) =>
            item.thpc_nm === selectedthpc &&
            item.dsst_nm === selecteddsst &&
            item.indication_nm === selectedindication &&
            item.brand_nm === selectedbrand
        );
        obj = {
          thpc_nm: selectedthpc,
          thpc_id: data.thpc_id || "",
          dsst_nm: selecteddsst,
          dsst_id: selecteddsst ? data.dsst_id : "",
          indication_nm: selectedindication,
          indication_id: selectedindication ? data.indctn_id : "",
          indication_grp_nm: data.indctn_grp_nm || "",
          indication_grp_id: data.indctn_grp_id || "",
          brand_nm: selectedbrand,
          brand_id: selectedbrand ? data.brnd_id : "",
          mdpr_nm: selectedmoelcule,
          mdpr_id: selectedmoelcule ? data.mdpr_id : "",
          list_quarter: listQuarter || "",
          list_type: listType || "",
          list_title: listTitle,
          department_field: selectedDepartment,
          updated_by: uuid,
        };
       }else if(selectListType === "thpc&dsst&mdpr"){
        const data = thpcdata.find(
          (item) =>
            item.list_type === "thpc&dsst&mdpr" &&
            item.thpc_nm === selectedthpc &&
            item.dsst_nm === selecteddsst &&
            item.mdpr_nm === selectedmoelcule
        );
        obj = {
          thpc_nm: selectedthpc,
          thpc_id: data.thpc_id || "",
          dsst_nm: selecteddsst,
          dsst_id: selecteddsst ? data.dsst_id : "",
          indication_nm: selectedindication,
          indication_id: selectedindication ? data.indctn_id : "",
          indication_grp_nm: data.indctn_grp_nm || "",
          indication_grp_id: data.indctn_grp_id || "",
          brand_nm: selectedbrand,
          brand_id: selectedbrand ? data.brnd_id : "",
          mdpr_nm: selectedmoelcule,
          mdpr_id: selectedmoelcule ? data.mdpr_id : "",
          list_quarter: listQuarter || "",
          list_type: listType || "",
          list_title: listTitle,
          department_field: selectedDepartment,
          updated_by: uuid,
        };
       }
      } else {
        if (selectListType === "thpconly") {
          const data = thpcdata.find(
            (item) =>
              item.list_type === "thpconly" && item.thpc_nm === selectedthpc
          );
          obj = {
            thpc_nm: selectedthpc,
            thpc_id: data.thpc_id || "",
            dsst_nm: selecteddsst,
            dsst_id: selecteddsst ? data.dsst_id : "",
            indication_nm: selectedindication,
            indication_id: selectedindication ? data.indctn_id : "",
            indication_grp_nm: data.indctn_grp_nm || "",
            indication_grp_id: data.indctn_grp_id || "",
            brand_nm: selectedbrand,
            brand_id: selectedbrand ? data.brnd_id : "",
            mdpr_nm: selectedmoelcule,
            mdpr_id: selectedmoelcule ? data.mdpr_id : "",
            list_quarter: listQuarter || "",
            list_type: listType || "",
            list_title: listTitle,
            department_field: selectedDepartment,
            updated_by: uuid,
          };
        } else if (selectListType === "thpc&dsst") {
          const data = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst
          );
          obj = {
            thpc_nm: selectedthpc,
            thpc_id: data.thpc_id || "",
            dsst_nm: selecteddsst,
            dsst_id: selecteddsst ? data.dsst_id : "",
            indication_nm: selectedindication,
            indication_id: selectedindication ? data.indctn_id : "",
            indication_grp_nm: data.indctn_grp_nm || "",
            indication_grp_id: data.indctn_grp_id || "",
            brand_nm: selectedbrand,
            brand_id: selectedbrand ? data.brnd_id : "",
            mdpr_nm: selectedmoelcule,
            mdpr_id: selectedmoelcule ? data.mdpr_id : "",
            list_quarter: listQuarter || "",
            list_type: listType || "",
            list_title: listTitle,
            department_field: selectedDepartment,
            updated_by: uuid,
          };
        } else if (selectListType === "thpc&dsst&mdpr") {
          const data = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst&mdpr" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.mdpr_nm === selectedmoelcule
          );
          obj = {
            thpc_nm: selectedthpc,
            thpc_id: data.thpc_id || "",
            dsst_nm: selecteddsst,
            dsst_id: selecteddsst ? data.dsst_id : "",
            indication_nm: selectedindication,
            indication_id: selectedindication ? data.indctn_id : "",
            indication_grp_nm: data.indctn_grp_nm || "",
            indication_grp_id: data.indctn_grp_id || "",
            brand_nm: selectedbrand,
            brand_id: selectedbrand ? data.brnd_id : "",
            mdpr_nm: selectedmoelcule,
            mdpr_id: selectedmoelcule ? data.mdpr_id : "",
            list_quarter: listQuarter || "",
            list_type: listType || "",
            list_title: listTitle,
            department_field: selectedDepartment,
            updated_by: uuid,
          };
        }
      }
    } else {
      obj = {
        thpc_nm: selectedthpc,
        thpc_id: getIdFromCascadingOptions("thpc", selectedthpc),
        dsst_nm: selecteddsst,
        dsst_id: getIdFromCascadingOptions("dsst", selecteddsst),
        indication_nm: selectedindication,
        indication_id: getIdFromCascadingOptions("indication", selectedindication),
        brand_nm: selectedbrand,
        brand_id: getIdFromCascadingOptions("brand", selectedbrand),
        mdpr_nm: selectedmoelcule,
        mdpr_id: getIdFromCascadingOptions("mdpr", selectedmoelcule),
        list_quarter: listQuarter || "",
        list_type: listType || "",
        list_title: listTitle,
        department_field: selectedDepartment,
        updated_by: uuid,
      };
    }
 
    saveMetaData(obj);
  };
 
  return (
    <>
      <div className="row">
        <div className="col-4">
          <LdsSelect
            id="departmentSelect"
            label="Department"
            name="departmentSelect"
            value={selectedDepartment}
            options={getDepartmentOptions()}
            onChange={(option) => {
              setSelectedDepartment(option.value);
              setSelectListType("");
            }}
          />
        </div>
        {selectedDepartment === "MEDICAL" && (
          <div className="col-4">
            <LdsSelect
              id="listtype"
              label="List Type"
              name="listtype"
              value={selectListType}
              options={[
                {
                  value: "",
                  label: "Select",
                },
                {
                  value: "thpconly",
                  label: "Therapeutic Area only",
                },
                {
                  value: "thpc&dsst",
                  label: "Therapeutic Area + Disease State",
                },
                {
                  value: "thpc&dsst&mdpr",
                  label: "Therapeutic Area + Disease State + Molecule",
                },
              ]}
              onChange={(option) => {
                setSelectListType(option.value);
              }}
            />
          </div>
        )}
        {selectedDepartment === "RETAIL" && (
          <div className="col-4">
            <LdsSelect
              id="listtype"
              label="List Type"
              name="listtype"
              value={selectListType}
              options={[
                {
                  value: "",
                  label: "Select",
                },
                {
                  value: "brnd&ind",
                  label: "Therapeutic Area + Disease State + Brand + Indication",
                },
                {
                  value: "thpc&dsst&mdpr",
                  label: "Therapeutic Area + Disease State + Molecule",
                },
              ]}
              onChange={(option) => {
                setSelectListType(option.value);
              }}
            />
          </div>
        )}
      </div>
      {selectedDepartment === "MEDICAL" && (
        <div className="row mt-3">
          {selectListType && (
            <div className="col-4">
              Therapeutic Area
              <Select
                id="selectedThpc"
                name="selectedThpc"
                value={getThpcOptions().find((option) => option.value === selectedthpc) || null}
                onChange={handlethpcChange}
                options={getThpcOptions()}
                isDisabled={selectedDepartment === "" || !selectListType || (modalType ? loading : thpcLoading)}
                isSearchable={true}
                isClearable={true}
                className="custom-select"
                placeholder="Select Therapeutic Area"
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "36px",
                    maxHeight: "108px",
                    overflowY: "auto",
                    whiteSpace: "normal",
                  }),
                }}
              />
            </div>
          )}
          {(selectListType === "thpc&dsst" ||
            selectListType === "thpc&dsst&mdpr") && (
            <div className="col-4">
              <label>Disease State</label>
              <Select
                id="selectedDsst"
                value={formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst").find(
                  (option) => option.value === selecteddsst
                ) || null}
                onChange={handledsstChange}
                options={formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst")}
                isSearchable={true}
                isClearable={true}
                isLoading={cascadingLoading.disease_state}
                isDisabled={!selectedthpc}
                placeholder="Select Disease State"
                className="custom-select"
              />
            </div>
          )}
          {selectListType === "thpc&dsst&mdpr" && (
            <div className="col-4">
              <label>Molecule</label>
              <Select
                id="selectedMolecule"
                value={formatOptionsForDropdown(cascadingOptions.molecule || [], "mdpr").find(
                  (option) => option.value === selectedmoelcule
                ) || null}
                onChange={handlemoleculeChange}
                options={formatOptionsForDropdown(cascadingOptions.molecule || [], "mdpr")}
                isSearchable={true}
                isClearable={true}
                isLoading={cascadingLoading.molecule}
                isDisabled={!selecteddsst}
                placeholder="Select Molecule"
                className="custom-select"
              />
            </div>
          )}
 
          {specialtyList?.list_quarter && [
              "spclty_hub_admin",
              "spclty_hub_super_admin",
              "spclty_hub_hcp_sf_marketer",
            ].includes(sessionStorage.getItem("role")) && (
            <div className="col col-12 col-md-2">
              Select Quarter
              <LdsSelect
                id="list_quarter"
                name="list_quarter"
                options={getQuarterOptions()}
                value={listQuarter}
                onChange={handleQuarter}
              ></LdsSelect>
            </div>
          )}
        </div>
      )}
      {selectedDepartment === "RETAIL" && selectListType === "brnd&ind" && (
        <div className="row mt-3">
          <div className="col-3">
            Therapeutic Area
            <Select
              id="selectedThpc"
              name="selectedThpc"
              value={getThpcOptions().find((option) => option.value === selectedthpc) || null}
              onChange={handlethpcChange}
              options={getThpcOptions()}
              isDisabled={selectedDepartment === "" || !selectListType || (modalType ? loading : thpcLoading)}
              isSearchable={true}
              isClearable={true}
              className="custom-select"
              placeholder="Select Therapeutic Area"
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "36px",
                  maxHeight: "108px",
                  overflowY: "auto",
                  whiteSpace: "normal",
                }),
              }}
            />
          </div>
          <div className="col-3">
            <label>Disease State</label>
            <Select
              id="selectedDsst"
              value={formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst").find(
                (option) => option.value === selecteddsst
              ) || null}
              onChange={handledsstChange}
              options={formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst")}
              isSearchable={true}
              isClearable={true}
              isLoading={cascadingLoading.disease_state}
              isDisabled={!selectedthpc}
              placeholder="Select Disease State"
              className="custom-select"
            />
          </div>
          <div className="col-3">
            <label>Brand</label>
            <Select
              id="selectedBrand"
              value={formatOptionsForDropdown(cascadingOptions.brand || [], "brand").find(
                (option) => option.value === selectedbrand
              ) || null}
              onChange={handleBrandChange}
              options={formatOptionsForDropdown(cascadingOptions.brand || [], "brand")}
              isSearchable={true}
              isClearable={true}
              isLoading={cascadingLoading.brand}
              isDisabled={!selecteddsst}
              placeholder="Select Brand"
              className="custom-select"
            />
          </div>
          <div className="col-3">
            <label>Indication</label>
            <Select
              id="selectedIndication"
              value={formatOptionsForDropdown(cascadingOptions.indication || [], "indication").find(
                (option) => option.value === selectedindication
              ) || null}
              onChange={handleIndicationChange}
              options={formatOptionsForDropdown(cascadingOptions.indication || [], "indication")}
              isSearchable={true}
              isClearable={true}
              isLoading={cascadingLoading.indication}
              isDisabled={!selectedbrand}
              placeholder="Select Indication"
              className="custom-select"
            />
          </div>
          {specialtyList?.list_quarter && [
              "spclty_hub_admin",
              "spclty_hub_super_admin",
              "spclty_hub_hcp_sf_marketer",
            ].includes(sessionStorage.getItem("role")) && (
            <div className="col col-12 col-md-2">
              Select Quarter
              <LdsSelect
                id="list_quarter"
                name="list_quarter"
                options={getQuarterOptions()}
                value={listQuarter}
                onChange={handleQuarter}
              ></LdsSelect>
            </div>
          )}
        </div>
      )}
      {selectedDepartment === "RETAIL" &&
        selectListType === "thpc&dsst&mdpr" && (
          <div className="row mt-3">
            <div className="col-4">
              Therapeutic Area
              <Select
                id="selectedThpc"
                name="selectedThpc"
                value={getThpcOptions().find((option) => option.value === selectedthpc) || null}
                onChange={handlethpcChange}
                options={getThpcOptions()}
                isDisabled={selectedDepartment === "" || !selectListType || (modalType ? loading : thpcLoading)}
                isSearchable={true}
                isClearable={true}
                className="custom-select"
                placeholder="Select Therapeutic Area"
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "36px",
                    maxHeight: "108px",
                    overflowY: "auto",
                    whiteSpace: "normal",
                  }),
                }}
              />
            </div>
            <div className="col-4">
              <label>Disease State</label>
              <Select
                id="selectedDsst"
                value={formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst").find(
                  (option) => option.value === selecteddsst
                ) || null}
                onChange={handledsstChange}
                options={formatOptionsForDropdown(cascadingOptions.disease_state || [], "dsst")}
                isSearchable={true}
                isClearable={true}
                isLoading={cascadingLoading.disease_state}
                isDisabled={!selectedthpc}
                placeholder="Select Disease State"
                className="custom-select"
              />
            </div>
            <div className="col-4">
              <label>Molecule</label>
              <Select
                id="selectedMolecule"
                value={formatOptionsForDropdown(cascadingOptions.molecule || [], "mdpr").find(
                  (option) => option.value === selectedmoelcule
                ) || null}
                onChange={handlemoleculeChange}
                options={formatOptionsForDropdown(cascadingOptions.molecule || [], "mdpr")}
                isSearchable={true}
                isClearable={true}
                isLoading={cascadingLoading.molecule}
                isDisabled={!selecteddsst}
                placeholder="Select Molecule"
                className="custom-select"
              />
            </div>
              {specialtyList?.list_quarter && [
                "spclty_hub_admin",
                "spclty_hub_super_admin",
                "spclty_hub_hcp_sf_marketer",
              ].includes(sessionStorage.getItem("role")) && (
              <div className="col col-12 col-md-2">
                Select Quarter
                <LdsSelect
                  id="list_quarter"
                  name="list_quarter"
                  options={getQuarterOptions()}
                  value={listQuarter}
                  onChange={handleQuarter}
                ></LdsSelect>
              </div>
            )}
          </div>
        )}
      <div className="row next-btn-blk">
        <div className="col col-12 col-md">
          <LdsButton
            classes={`
                    "button-icon-right ${
                      isNextButtonDisabled ? "" : "blue-btn"
                    } mrgn-rt"
                  `}
            disabled={isNextButtonDisabled}
            onClick={createMetaData}
          >
            Save
          </LdsButton>
          <LdsButton
            classes="button-icon-right blue-bdr-btn ml-2"
            onClick={closeBrandIndicationEdit}
          >
            Cancel
          </LdsButton>
        </div>
      </div>
      <LdsToast />
    </>
  );
};
 
export default EditBrandIndication;